import React, { useEffect } from "react";
import Lenis from "lenis";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { Footer } from "@/components/Sections";
import { scrollToId } from "@/config";
import { CALC_META } from "@/components/calculators/meta";

const useLenis = () => {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
};

const useRouteScroll = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (pathname === "/calculators" && hash && CALC_META[hash.slice(1)]) {
      navigate(`/calculators/${CALC_META[hash.slice(1)].slug}`, { replace: true });
      return;
    }
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash, navigate]);
};

export const SiteLayout = () => {
  useLenis();
  useRouteScroll();
  return (
    <div className="min-h-screen bg-lightbg pb-24 lg:pb-0">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};
